import { getSessionInfo } from './getSessionInfo';

export const hasValidSession = () => {
	const { userInfo, locationId } = getSessionInfo();
	return !!(userInfo && locationId);
};

export const hasUserInfo = () => {
	const { userInfo } = getSessionInfo();
	return !!userInfo;
};

export const hasLocationSelected = () => {
	const { locationId } = getSessionInfo();
	return !!locationId;
};

export const getValidSession = () => {
	const session = getSessionInfo();
	if (session.userInfo && session.locationId) {
		return session;
	}
	return null;
};
